module.exports = __webpack_public_path__ + "img/bannerLogin.72564a24.png";